export function routePathOpacity(isSelected: boolean, style: string): number {
  let opacity: number;
  if (isSelected) {
    switch (style) {
      case 'satellite':
      case 'basic_dark':
      case 'datadark':
      case 'transportation_dark':
      case 'dark_accessible':
        opacity = 0.7;
        break;
      default:
        opacity = 0.6;
    }
  } else {
    switch (style) {
      case 'satellite':
      case 'basic_dark':
      case 'datadark':
      case 'transportation_dark':
      case 'dark_accessible':
        opacity = 0.5;
        break;
      default:
        opacity = 0.3;
    }
  }
  return opacity;
}
